import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Stack, Typography, Divider, List, ListItem, ListItemText, ListItemIcon, } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTokens } from '@mcn-platform/models';
const LearningObjectives = ({ objectives, showDividers }) => {
    const tokens = useTokens();
    return (_jsxs(Stack, { children: [_jsx(Typography, { variant: "subtitle1", className: "landingpage-section-subheader", children: tokens.getToken('learningObjectivesLabel') }), _jsx(List, { sx: { pt: 1.5 }, children: objectives && objectives.split('&#8226;').map((objective, index) => (_jsxs(React.Fragment, { children: [showDividers && (_jsx(Divider, { sx: {
                                mb: 1,
                                borderColor: (t) => (t.portal?.site?.lineColor),
                            } })), _jsxs(ListItem, { dense: true, children: [_jsx(ListItemIcon, { sx: {
                                        marginBottom: 'auto',
                                        pt: 0.375,
                                        minWidth: 20,
                                    }, children: _jsx(ArrowForwardIcon, { sx: {
                                            fontSize: 16,
                                            color: (t) => t.portal.landingPage.bullet.color,
                                        } }) }), _jsx(ListItemText, { disableTypography: true, sx: {
                                        m: 0,
                                    }, primary: (_jsx(Typography, { component: "span", fontWeight: "fontWeightRegular", sx: {
                                            color: (t) => (t.portal.landingPage.sectionText.font.color),
                                            typography: 'body2',
                                            pt: 0,
                                            fontSize: '0.90rem',
                                        }, children: objective })) })] }), showDividers && (objectives.length - 1) === index && (_jsx(Divider, { sx: {
                                borderColor: (t) => (t.portal.site.lineColor),
                            } }))] }, `${index}-key`))) })] }));
};
LearningObjectives.defaultProps = {
    showDividers: false,
};
export default LearningObjectives;
//# sourceMappingURL=LearningObjectives.js.map